<template>
  <Widget />
</template>

<script>
import Widget from './components/Widget.vue';

export default {
  name: 'App',
  components: {
    Widget
  }
}
</script>

<style lang="scss">
@import "./scss/responsive.scss";

#adhesion-non-pro {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #643773;
  box-sizing: border-box;

  .error {
    border: 2px solid crimson;
  }

  form {
    display: flex;
    flex-direction: column;

    label {
      text-align: left;
      margin-top: 1rem;
    }

    input,
    select {
      padding: 0.5rem;
      border-radius: 5px;
    }
  }
}
</style>
